import * as React from "react";

const CheckboxIndeterminate: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M17.143 10.286a1.714 1.714 0 010 3.428H6.857a1.714 1.714 0 010-3.428h10.286z"
            />
        </svg>
    );
};

export default React.memo(CheckboxIndeterminate);
